// extracted by mini-css-extract-plugin
export default {"AppLoader":"AppLoader__AppLoader___Hc812","container":"AppLoader__container___xInyv","loaderText":"AppLoader__loaderText___EGPa_"};